// extracted by mini-css-extract-plugin
module.exports = {"logoGallery":"logoGallery-module--logoGallery--xxOui","logoGalleryItem":"logoGallery-module--logoGalleryItem--yvKcC","filter":"logoGallery-module--filter--1TNTN"};